import { shadowColor } from 'theme/color';

export const messagingCont = {
  borderRadius: '5px',
  // boxShadow: `0px 1px 8px ${shadowColor}`,
  border: '0.5px solid #E4E4E4',
  padding: '15px',
  gap: '10px',
  height: '100%',
};

export const messageCardCont = {
  boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.15)',
  borderRadius: '5px',
  padding: '15px',
  marginTop: '10px',
  marginX: '4px',
  display: 'flex',
};

export const MEPChat = {
  width: ' 500px !important',
  height: '500px !important',
};
